/* eslint-disable no-undef */

import 'phaser';
import { Button } from "../Entities/GlobalEntities"
import { AddImageToScene, loadImage } from "./../modules/utiltes"
export class SceneMainMenu extends Phaser.Scene {
    constructor() {
        super({
            key: 'SceneMainMenu',
        });
    }

    init(data) {
        // Access the mode parameter passed from Scene 1
        this.mode = data.mode;
    }

    preload() {
        loadImage(this, 'deepspace-menu', 'assets/img/game/Background-5.png')
        loadImage(this, 'stargametbtn', 'assets/img/game/StartGame.png')
        loadImage(this, 'topscorestbtn', 'assets/img/game/TopScores.png')
    }

    create() {
        this.bg = AddImageToScene(this, 'deepspace-menu')
        this.title = this.add.text(this.game.config.width * 0.5, 128, 'SafeMoon Defenders', {
            fontFamily: 'monospace',
            fontSize: 30,
            fontStyle: 'bold',
            color: '#ffffff',
            align: 'center',
        });
        this.title.setOrigin(0.5);
        this.stargametbtn = new Button(
            this,
            250,
            300,
            'stargametbtn'

        )
        this.stargametbtn.setInteractive()
        this.stargametbtn.on('pointerdown', function(pointer) {

            this.setTint(0x6B128B);

        });
        this.stargametbtn.on('pointerup', (pointer) => {

            this.scene.start('SceneIntro', { mode: this.mode });

        });
        this.stargametbtn.on('pointerout', function(pointer) {

            this.clearTint();

        });
        this.topscorestbtn = new Button(
            this,
            250,
            400,
            'topscorestbtn'

        )
        this.topscorestbtn.setInteractive()
        this.topscorestbtn.on('pointerdown', function(pointer) {

            this.setTint(0x6B128B);

        });
        this.topscorestbtn.on('pointerup', (pointer) => {

            this.scene.start('SceneTopScoresMenu', {mode: this.mode})

        });
        this.topscorestbtn.on('pointerout', function(pointer) {

            this.clearTint();

        });
    }
}